import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["clientUsername"];
import _String$raw from "@babel/runtime-corejs3/core-js/string/raw";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import PhoneInput from "@Shared/components/inputs/phone-input";
import SectionError from "@Shared/components/sections/section-error.vue";
import ValidPayload from "@Shared/utils/shared-mixins/valid-payload-mixin";
import { CREATE_APPLICATION, CREATE_ADDITIONAL_APPLICATION } from "../store/applications-list-actions";
import { flattenDepth, isEmpty } from "lodash";
import LangSelector from "@Shared/components/i18n/lang-selector.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FullApplicationMethod",
  components: {
    PhoneInput,
    SimpleButton,
    LangSelector,
    SectionError
  },
  mixins: [ValidPayload],
  props: {
    requestPersonalDetails: {
      type: Boolean,
      default: false
    },
    additional: {
      type: Boolean,
      default: false
    },
    clientUsername: {
      type: String,
      default: ""
    },
    clientDetails: {
      type: Object,
      default: () => ({})
    },
    clientProfileId: {
      type: [String, Number],
      default: ""
    },
    agentUsername: {
      type: String,
      default: ""
    },
    showIncludeCoApplicants: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      client: _objectSpread({}, this.clientDetails),
      coApplicants: false,
      buttonIsLoading: false,
      createFailed: false,
      locale: this.$root.$i18n.locale
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("ApplicationsListStore", ["flows"])), {}, {
    isValid() {
      const pattern = _String$raw`^$|^[^\s@]+@[^\s@]+\.[^\s@]+$`;
      const regex = new RegExp(pattern);
      const requiredFields = ["givenName", "familyName", "flow"];
      return this.isValidPayload(this.client, requiredFields) && regex.test(this.client.email);
    },
    displayErrorMessage() {
      if (!this.client.email) return "";
      const pattern = _String$raw`^\S+@\S+\.\S+$`;
      const regex = new RegExp(pattern);
      if (!regex.test(this.client.email)) {
        return this.$t("form-validations.validEmail.full");
      }
      return "";
    },
    flowsColumns() {
      var _context;
      if (isEmpty(this.flows) || !this.flows.sections.length) return [];
      const options = _mapInstanceProperty(_context = this.flows.sections).call(_context, sections => {
        var _context2;
        return _mapInstanceProperty(_context2 = sections.columns).call(_context2, column => column.options);
      });
      return flattenDepth(options, 2);
    }
  }),
  watch: {
    clientDetails(val) {
      this.client = _objectSpread({}, val);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationsListStore", [CREATE_APPLICATION, CREATE_ADDITIONAL_APPLICATION])), {}, {
    handleClick() {
      this.$emit("back");
    },
    redirectToApplication(_ref) {
      let {
          clientUsername
        } = _ref,
        params = _objectWithoutProperties(_ref, _excluded);
      this.$emit("hide");
      window.location = `#/clients/applications/${clientUsername}?${$.param(params)}`;
    },
    async createApplication() {
      try {
        this.buttonIsLoading = true;
        const {
          clientUsername,
          agentUsername,
          clientProfileId,
          locale
        } = this;
        if (!this.additional) {
          const details = await this.CREATE_APPLICATION(_objectSpread(_objectSpread({}, this.client), {}, {
            agentUsername,
            clientProfileId,
            locale
          }));
          return this.redirectToApplication(_objectSpread(_objectSpread({}, details), {}, {
            agentUsername
          }));
        }
        const data = {
          copyItems: ["main-applicant"],
          flow: this.client.flow
        };
        if (this.coApplicants) data.copyItems.push("co-applicants");
        const details = await this.CREATE_ADDITIONAL_APPLICATION({
          data,
          clientUsername,
          agentUsername,
          clientProfileId
        });
        return this.redirectToApplication(details);
      } catch (e) {
        this.createFailed = true;
      } finally {
        this.buttonIsLoading = false;
      }
    }
  })
});